var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", { staticClass: "col-md-6 col-sm-12 card" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("link-to", { staticClass: "image", attrs: { to: _vm.link } }, [
          _c("img", { staticClass: "size-2", attrs: { src: _vm.image } }),
          _vm.clickable !== false
            ? _c("div", { staticClass: "more upper" }, [_vm._v("Подробнее")])
            : _vm._e()
        ]),
        _vm.clickable
          ? _c("link-to", { staticClass: "title", attrs: { to: _vm.link } }, [
              _c("h2", { domProps: { innerHTML: _vm._s(_vm.title) } })
            ])
          : _vm._e(),
        !_vm.clickable
          ? _c("div", { staticClass: "title-nohover" }, [
              _c("h2", { domProps: { innerHTML: _vm._s(_vm.title) } })
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dd6b2eda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd6b2eda","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shared/cards/CardProductSmall.vue
// module id = 4n8E
// module chunks = 10 11 12 13 14 15 17 28